import Api from '../../../../services/api';
import moment from 'moment'
import React, { useEffect, useMemo, useRef, useState } from 'react';
import MaskedInput from 'react-input-mask'
import {
    Upload, Popconfirm, message, Form, Input, Spin,
    Checkbox, Card, DatePicker,
    Button, Select, Menu, Table
} from 'antd';
import { EDocumentoDescricao, EDocumentoID } from '../../../../components/enums/documento.enum'
import { UploadOutlined } from '@ant-design/icons';
import { useParams, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PermissaoAction from '../../../../redux/actions/permissao';
import axios from 'axios';
import EditorTexto from '../../../../components/EditorTexto';
import { isValidCPF, validarCPF } from '../../../../utils/cpf';
import { validateNISorCPF } from '../../../../utils/nis';
import { tipoDocumentoService } from '../../../../services/Tipo-Documento-Service/tipo-documento-service';
import { LocalidadeService } from '../../../../services/Localidade-Service/localidade-service';


interface props {
    dados: any;
    arquivos: any;
    permissao?: any;
    placeholder?: any;
}

const Documentacao: React.FC<props> = (props) => {
    const [outro, setOutro] = useState<boolean>(true);
    const { TextArea } = Input;
    const [file, setFile] = useState<any>();
    const [loading, setLoading] = useState(false);
    const [loadingArquivos, setLoadingArquivos] = useState(false);
    const { id } = useParams<Record<string, string | undefined>>();
    const { agendamentoID } = useParams<Record<string, string | undefined>>();
    const [form] = Form.useForm();
    const [documentacaoID, setDocumentacaoID] = useState<number | undefined>();
    const [chamanteID, setChamanteID] = useState<number>(0);
    const [documentoID, setDocumentoID] = useState<number>();
    const [arquivos, setArquivos] = useState<{ key: number, tipoDocumento: string, arquivoURL: string, contentType: string }[]>([]);
    const [checkedCartaoSus, setCheckedCartaoSus] = useState(false);
    const [necessitaDataRn, setNecessitaDataRn] = useState<boolean>();
    const [necessitaLocalRegistro, setNecessitaLocalRegistro] = useState<boolean>();
    const [numeroCartaoSus, setNumeroCartaoSus] = useState<any>();
    const [permissaoUserEditar, setPermissaoUserEditar] = useState<boolean>(false);
    const [editorState, setEditorState] = useState("");
    const [tipoDocumentos, setTipoDocumentos] = useState<any[]>();
    const [paises, setPaises] = useState<any[]>();

    let location = useLocation();
    var currentLocation = location.pathname

    let paths = currentLocation.split('/');

    const colunas = [
        {
            title: 'Tipo Documento',
            dataIndex: 'tipoDocumento',
            key: 'tipoDocumento',
        },
        {
            title: 'Ação',
            dataIndex: '',
            key: 'x',
            render: (text: any, record: any) => (
                <>
                    {permissaoUserEditar === true ?
                        <Popconfirm placement="top" title="Você tem certeza que deseja excluir o documento?" onConfirm={(e) => { onDelete(record.key); }} okText="Sim" cancelText="Não">
                            <Button>  Excluir </Button>
                        </Popconfirm>
                        : null}
                    <Button onClick={(e: any) => { baixarArquivo(record.arquivoURL, record.tipoDocumento, record.contentType) }}>Baixar </Button>
                </>
            ),
        }
    ]

    const baixarArquivo = (id: number, nome: string, contentType: string) => {
        setLoadingArquivos(true);
        Api.get(`Arquivo/downloadbase64?id=${id}`)
            .then((response) => {
                if (response !== null && contentType != null) {
                    var link = document.createElement('a');
                    link.innerHTML = 'Download file';
                    link.download = nome;
                    link.href = 'data:' + contentType + ';base64,' + response?.data.arquivo
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')

            }).finally(() => {
                setLoadingArquivos(false);
            })
    }

    const documento = [
        { id: EDocumentoID.Cpf, desc: EDocumentoDescricao.Cpf },
        { id: EDocumentoID.CarteiraTrabalho, desc: EDocumentoDescricao.CarteiraTrabalho },
        { id: EDocumentoID.Passsaporte, desc: EDocumentoDescricao.Passsaporte },
        { id: EDocumentoID.Cnh, desc: EDocumentoDescricao.Cnh },
        { id: EDocumentoID.Rnm, desc: EDocumentoDescricao.Rnm },
        { id: EDocumentoID.ComprovanteResidenacia, desc: EDocumentoDescricao.ComprovanteResidenacia },
        { id: EDocumentoID.CertidaoNascimento, desc: EDocumentoDescricao.CertidaoNascimento },
        { id: 0, desc: "Outro" }
    ]

    useEffect(() => {
        let validadeRnm = new Date(Date.parse(props.dados?.validadeRnm)).toLocaleDateString();
        let expedicaoRnm = new Date(Date.parse(props.dados?.expedicaoRnm)).toLocaleDateString();
        let dataEmissaoRn = new Date(Date.parse(props.dados?.dataEmissaoRn)).toLocaleDateString();
        form.setFieldsValue({
            identidadeRn: props.dados?.identidadeRn,
            cpf: props.dados?.cpf,
            nis: props.dados?.nis,
            passaporte: props.dados?.passaporte,
            numeroNif: props.dados?.numeroNif,
            paisEmissor: props.dados?.paisEmissor,
            numeroCartaoSus: props.dados?.numeroCartaoSus,
            rnm: props.dados?.rnm,
            anotacoesGerais: props.dados?.anotacoesGerais,
            dadosCadastraisID: props.dados?.dadosCadastraisID,
            folhaCertidaoNascimento: props.dados?.folhaCertidaoNascimento,
            livroCertidaoNascimento: props.dados?.livroCertidaoNascimento,
            termoCertidaoNascimento: props.dados?.termoCertidaoNascimento,
            rnmChamante: props.dados?.chamante?.rnm,
            cpfChamante: props.dados?.chamante?.cpf,
            localRegistroCertidaoNascimento: props.dados?.localRegistroCertidaoNascimento,
            validadeRnm: props.dados?.validadeRnm ?
                validadeRnm : null,
            classificacaoRnm: props.dados?.classificacaoRnm,
            expedicaoRnm: props.dados?.expedicaoRnm ?
                expedicaoRnm : null,
            dataEmissaoRn: props.dados?.dataEmissaoRn ?
                dataEmissaoRn : null
        });
        if (props.dados?.numeroCartaoSus != null) {
            setCheckedCartaoSus(true)
        }
        setNecessitaDataRn(props.dados?.identidadeRn?.length > 0 ? true : false)
        setNecessitaLocalRegistro(props.dados?.folhaCertidaoNascimento?.length > 0 ? true : false)
        setDocumentacaoID(props.dados?.documentacaoID);
        setChamanteID(props.dados?.chamanteID);
        mapArquivos();
        if (paths[4] == "agendamento" && props.permissao[0].permissaoAcesso?.editar == false) {
            setPermissaoUserEditar(true);
        } else {
            setPermissaoUserEditar(props.permissao[0].permissaoAcesso?.editar);
        }
        var anotacoesGerais = props.dados?.anotacoesGeraisHTML != undefined ? props.dados?.anotacoesGeraisHTML : props.dados?.anotacoesGerais != undefined ? props.dados?.anotacoesGerais : "";
        setEditorState(anotacoesGerais)
        getTipoDocumentos();
        buscaPaises();

    }, [props.dados, props.arquivos])


    const buscaPaises = async () => {

        await LocalidadeService.getPaises(setLoading).then((res) => setPaises(res));

    }

    const getTipoDocumentos = () => {
        try {
            tipoDocumentoService.get().then(res => {
                if (res.status == 200)
                    setTipoDocumentos(res.data)
            })
        }
        catch {
            message.error("Falha ao carregar Tipo Documentos")
        }
    }

    const mapArquivos = () => {
        try {
            setArquivos(props.arquivos?.map((itemFile: any) => {
                return {
                    key: itemFile.arquivoID,
                    tipoDocumento: itemFile?.tipoDocumento?.nome?.toLowerCase().includes('outros') ? itemFile?.outro : itemFile?.tipoDocumento?.nome,
                    arquivoURL: itemFile.arquivoURL,
                    contentType: itemFile.contentType
                }
            }))
        }
        catch {
            message.error("Falha ao carregar arquivos")
        }
    }

    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [DD, MM, YYYY] = dateTimeString.split('/');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}`;
    }

    const validarDataValidadeRnm = (_: any, value: { number: number }) => {
        if (form.getFieldValue("validadeRnm") != undefined) {

            let result, data;
            let dataFormatada = toISOFormat(form.getFieldValue("validadeRnm"));
            data = new Date(dataFormatada);
            result = moment(data).isValid();
            if (result == false) {
                return Promise.reject(new Error('Data inválida!'));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    const validarDataExpedicaoRnm = (_: any, value: { number: number }) => {
        if (form.getFieldValue("expedicaoRnm") != undefined) {
            let result, data;
            let dataFormatada = toISOFormat(form.getFieldValue("expedicaoRnm"));
            data = new Date(dataFormatada);
            result = moment(data).isValid();
            if (result == false) {
                return Promise.reject(new Error('Data inválida!'));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    // const validarDataEmissaoRn = (_: any, value: { number: number }) => {
    //     if (!value) {
    //         return Promise.resolve(); // Permite salvar o campo vazio
    //     }

    //     // if (value && value.number === null) {
    //     //     return Promise.resolve(); // Permite salvar quando o campo é clicado, mas nada é digitado
    //     // }

    //     let result, data;
    //     let dataFormatada = toISOFormat(form.getFieldValue("dataEmissaoRn"));
    //     data = new Date(dataFormatada);
    //     result = moment(data).isValid();
    //     if (!result) {
    //         return Promise.reject(new Error('Data inválida!')); // Gera erro ao inserir uma data inválida
    //     }
    //     return Promise.resolve();
    // };    

    const validarDataEmissaoRn = (_: any, value: { number: number }) => {
        if (!value) {
            return Promise.resolve(); // Permite salvar o campo vazio
        }

        if (value && value.number === null) {
            return Promise.resolve(); // Permite salvar quando o campo é clicado, mas nada é digitado
        }

        let result, data;
        let dataFormatada = toISOFormat(form.getFieldValue("dataEmissaoRn"));
        data = new Date(dataFormatada);
        result = moment(data).isValid();
        if (!result) {
            return Promise.reject(new Error('Data inválida!')); // Gera erro ao inserir uma data inválida
        }
        return Promise.resolve();
    };


    const submit = async (value: any) => {
        setLoading(true);
        var anotacoesGeraisTexto = new DOMParser().parseFromString((editorState), 'text/html').body.textContent;

        if (documentacaoID !== null && documentacaoID !== undefined) {
            let dataValidadeRnm, dataExpedicaoRnm, dataEmissaoRn;
            if (value.validadeRnm != undefined) {
                let dataFormatada = toISOFormat(value.validadeRnm);
                dataValidadeRnm = new Date(dataFormatada);
            }
            if (value.expedicaoRnm != undefined) {
                let dataFormatada = toISOFormat(value.expedicaoRnm);
                dataExpedicaoRnm = new Date(dataFormatada);
            }
            if (value.dataEmissaoRn != undefined) {
                let dataFormatada = toISOFormat(value.dataEmissaoRn);
                dataEmissaoRn = new Date(dataFormatada);
            }
            await Api.put("Documentacao", {
                DocumentacaoID: documentacaoID,
                IdentidadeRn: value.identidadeRn,
                Cpf: value.cpf,
                NIS: value.nis,
                Passaporte: value.passaporte,
                NumeroNif: value.numeroNif,
                PaisEmissor: value.paisEmissor,
                NumeroCartaoSus: value.numeroCartaoSus,
                CartaoSus: checkedCartaoSus,
                Rnm: value.rnm,
                AnotacoesGerais: anotacoesGeraisTexto,
                AnotacoesGeraisHTML: editorState,
                DadosCadastraisID: id ? parseInt(id) : 0,
                FolhaCertidaoNascimento: value.folhaCertidaoNascimento,
                LivroCertidaoNascimento: value.livroCertidaoNascimento,
                TermoCertidaoNascimento: value.termoCertidaoNascimento,
                Chamante: {
                    ChamanteID: chamanteID ? chamanteID : 0,
                    Rnm: value.rnmChamante,
                    Cpf: value.cpfChamante,
                },
                ChamanteID: chamanteID ? chamanteID : 0,
                LocalRegistroCertidaoNascimento: value.localRegistroCertidaoNascimento,
                ValidadeRnm: dataValidadeRnm,
                ClassificacaoRnm: value.classificacaoRnm,
                ExpedicaoRnm: dataExpedicaoRnm,
                DataEmissaoRn: dataEmissaoRn,
                AgendamentoID: agendamentoID ? parseInt(agendamentoID) : 0,
                Arquivos: null
            })
                .then((response) => {
                    message.success('Salvo com sucesso')
                })
                .catch((err) => {
                    message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição')
                })
                .finally(() => {
                    setLoading(false);
                })
        }
        else {
            let dataValidadeRnm, dataExpedicaoRnm, dataEmissaoRn;
            if (value.validadeRnm != undefined) {
                let dataFormatada = toISOFormat(value.validadeRnm);
                dataValidadeRnm = new Date(dataFormatada);
            }
            if (value.expedicaoRnm != undefined) {
                let dataFormatada = toISOFormat(value.expedicaoRnm);
                dataExpedicaoRnm = new Date(dataFormatada);
            }
            if (value.dataEmissaoRn != undefined) {
                let dataFormatada = toISOFormat(value.dataEmissaoRn);
                dataEmissaoRn = new Date(dataFormatada);
            }
            await Api.post("Documentacao", {
                IdentidadeRn: value.identidadeRn,
                Cpf: value.cpf,
                NIS: value.nis,
                Passaporte: value.passaporte,
                NumeroNif: value.numeroNif,
                PaisEmissor: value.paisEmissor,
                NumeroCartaoSus: value.numeroCartaoSus,
                CartaoSus: checkedCartaoSus,
                Rnm: value.rnm,
                AnotacoesGerais: anotacoesGeraisTexto,
                AnotacoesGeraisHTML: editorState,
                DadosCadastraisID: id ? parseInt(id) : 0,
                FolhaCertidaoNascimento: value.folhaCertidaoNascimento,
                LivroCertidaoNascimento: value.livroCertidaoNascimento,
                TermoCertidaoNascimento: value.termoCertidaoNascimento,
                LocalRegistroCertidaoNascimento: value.localRegistroCertidaoNascimento,
                ValidadeRnm: dataValidadeRnm,
                ClassificacaoRnm: value.classificacaoRnm,
                Chamante: {
                    Rnm: value.rnmChamante,
                    Cpf: value.cpfChamante,
                },
                ExpedicaoRnm: dataExpedicaoRnm,
                DataEmissaoRn: dataEmissaoRn,
                AgendamentoID: agendamentoID ? parseInt(agendamentoID) : 0,
                Arquivos: null
            })
                .then((response) => {
                    setDocumentacaoID(response?.data?.documentacao?.documentacaoID);
                    message.success('Salvo com sucesso')
                })
                .catch((err) => {
                    message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição')
                }).finally(() => {
                    setLoading(false);
                })
        }

    }
    const uploadRequest = async () => {
        if (file !== undefined && form.getFieldValue('documento') !== undefined) {

            let formData = new FormData();
            formData.append("file", file.originFileObj);
            var documentoID = form.getFieldValue('documento');
            var outro = documentoID == 8 ? form.getFieldValue('outro') : null;
            if (outro !== "" && outro !== undefined) {
                await Api
                    .post(`Arquivo/uploadfile?DadosCadastraisID=${id}&documentoID=${documentoID}&outro=${outro}`, formData)
                    .then(res => {
                        var array = arquivos.slice();

                        array.unshift({
                            key: res?.data?.arquivo.arquivoID,
                            tipoDocumento: documentoID == 8 ? outro?.toUpperCase() : res?.data?.arquivo?.tipoDocumento?.nome,
                            arquivoURL: res?.data?.arquivo.arquivoURL,
                            contentType: res?.data?.arquivo.contentType
                        })
                        setArquivos(array);
                        message.success("Salvo com sucesso!")

                    })
                    .catch(err => {
                        message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição')
                    });
            } else {
                message.warning("Atenção! Preencha descrição outro.")
            }

        }
        else {
            message.warning("Atenção! Preencha o campo documento e anexe um arquivo.")
        }
    }

    const handleUpload = (e: any) => {
        setFile(e.fileList[0]);
    }

    const onDelete = async (record: number) => {
        setLoadingArquivos(true);
        await Api
            .delete(`Arquivo?id=${record}`)
            .then(res => {
                setArquivos(arquivos.filter((item) => { return item.key !== record })
                )
                message.success("Removido com sucesso");
            })
            .catch(err => {
                message.error("Falha na remoção");
            }).finally(() => {
                setLoadingArquivos(false);
            })

    }

    const buscarCartaoSUS = (e: any) => {
        var cpf = e.replace(/\.|\-|\_/g, '');
        if (isValidCPF(cpf)) {
            setLoading(true);
            let susApiUrl = process.env.REACT_APP_CARTAOSUS_URL;
            axios.get(`${susApiUrl}${cpf}`, { headers: { 'Authorization': 'Bearer ' + sessionStorage.getItem('Token') + "" } })
                .then((response: any) => {
                    setCheckedCartaoSus(true)
                    form.setFieldsValue({
                        numeroCartaoSus: response.data.data.numeroCartao
                    })
                }).finally(() => {
                    setLoading(false)
                }).catch((error) => {
                    message.error("Não foi possível buscar o cartão do SUS com esse CPF.")
                })
        }
        else {
            setCheckedCartaoSus(false);
            setNumeroCartaoSus(null);
        }
    }

    return (
        <>
            <div className="container">
                <div className="form-pesquisa">
                    <Spin spinning={loading}>
                        <Form onFinish={submit}
                            form={form}
                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            layout="horizontal"
                            size="middle"                        >
                            <div className="row">
                                <div className="col-md-5">
                                    <div className="site-card-border-less-wrapper">
                                        <Card title="Identidade/RN" bordered={false} style={{ background: "#ececec" }}>
                                            <Form.Item name="identidadeRn" label="Número">
                                                <Input onChange={(e: any) => { e.target.value != 0 ? setNecessitaDataRn(true) : setNecessitaDataRn(false) }} placeholder="Número do documento"
                                                    disabled={permissaoUserEditar === false}
                                                />
                                            </Form.Item>
                                            {necessitaDataRn ?
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <Form.Item name="paisEmissor" label="País emissor" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    message: 'Por favor insira o pais Emissão!',
                                                                }
                                                            ]}
                                                        >
                                                            <Select
                                                                showSearch
                                                                optionFilterProp="children"
                                                                placeholder="Selecione um País"
                                                            >

                                                                {paises?.map((p, index) => <Select.Option key={index} value={p.name?.toUpperCase()}>{p.name?.toUpperCase()}</Select.Option>)}

                                                            </Select>
                                                        </Form.Item>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <Form.Item name="dataEmissaoRn" label="Data Emissão RN" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                                                            rules={[
                                                                {
                                                                    validator: validarDataEmissaoRn
                                                                }
                                                            ]}>
                                                            <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />

                                                            {/* <DatePicker placeholder="Selecione uma Data" format="DD/MM/YYYY"
                                                                disabled={permissaoUserEditar === false}
                                                            ></DatePicker> */}
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                                :
                                                <Form.Item name="paisEmissor" label="País emissor" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                                    <Select
                                                        showSearch
                                                        optionFilterProp="children"
                                                        placeholder="Selecione um País"
                                                        disabled={permissaoUserEditar === false}
                                                    >

                                                                {paises?.map((p, index) => <Select.Option key={index} value={p.name?.toUpperCase()}>{p.name?.toUpperCase()}</Select.Option>)}

                                                    </Select>
                                                </Form.Item>
                                            }

                                        </Card>
                                    </div>

                                </div>
                                <div className="col-md-7">
                                    <Card title="Certidão de Nascimento" bordered={false} style={{ background: "#ececec" }}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Form.Item name="folhaCertidaoNascimento" label="Folha" >
                                                    <Input maxLength={10} onChange={(e: any) => { e.target.value != "" ? setNecessitaLocalRegistro(true) : setNecessitaLocalRegistro(false) }}
                                                        disabled={permissaoUserEditar === false}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Item name="livroCertidaoNascimento" label="Livro" >
                                                    <Input maxLength={10} onChange={(e: any) => { e.target.value != "" ? setNecessitaLocalRegistro(true) : setNecessitaLocalRegistro(false) }}
                                                        disabled={permissaoUserEditar === false}
                                                    />
                                                </Form.Item>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Form.Item name="termoCertidaoNascimento" label="Termo" >
                                                    <Input maxLength={10} onChange={(e: any) => { e.target.value != "" ? setNecessitaLocalRegistro(true) : setNecessitaLocalRegistro(false) }}
                                                        disabled={permissaoUserEditar === false}
                                                    />
                                                </Form.Item>
                                            </div>
                                            {necessitaLocalRegistro ?
                                                <div className="col-md-6">
                                                    <Form.Item name="localRegistroCertidaoNascimento" label="Local Registro"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Por favor insira o Local de Registro!',
                                                            }
                                                        ]} >
                                                        <Select
                                                            showSearch
                                                            optionFilterProp="children"
                                                            placeholder="Selecione um País"
                                                        >

                                                                {paises?.map((p, index) => <Select.Option key={index} value={p.name?.toUpperCase()}>{p.name?.toUpperCase()}</Select.Option>)}

                                                        </Select>
                                                    </Form.Item>
                                                </div>
                                                : null
                                            }

                                        </div>

                                    </Card>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-5">
                                    <Card title="Gerais" bordered={false} style={{ background: "#ececec" }}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Form.Item name="cpf" label="CPF" rules={[{ validator: (_, value) => { return validarCPF(value) } }]}>
                                                    <MaskedInput mask="999.999.999-99" placeholder="Informe um CPF" onBlur={(e: any) => { buscarCartaoSUS(e.target.value) }} className='globalInput'
                                                        disabled={permissaoUserEditar === false}></MaskedInput>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Item name="passaporte" label="Passaporte">
                                                    <Input placeholder="Informe um passaporte"
                                                        disabled={permissaoUserEditar === false}
                                                    ></Input>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Form.Item name="numeroNif" label="NIF">
                                                    <Input placeholder="N. de Identificação Fiscal" title="Número de identificação fiscal"
                                                        disabled={permissaoUserEditar === false}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-6">
                                                <Form.Item name="nis" label="NIS" rules={[
                                                    { validator: () => { return validateNISorCPF(form.getFieldValue("nis")) } }
                                                ]}>
                                                    <MaskedInput mask="99999999999" placeholder="Informe um NIS" className='globalInput'
                                                        disabled={permissaoUserEditar === false}></MaskedInput>
                                                </Form.Item>
                                            </div>

                                        </div>
                                        <div className='row'>
                                            {checkedCartaoSus ?
                                                <div className="col-md-6">
                                                    <Form.Item name="numeroCartaoSus" label="cartão SUS" >
                                                        <Input value={numeroCartaoSus} placeholder="N. Cartão SUS" title="Número Cartão SUS"
                                                            disabled={true}
                                                        />
                                                    </Form.Item>
                                                </div>
                                                : null
                                            }
                                        </div>
                                    </Card>
                                </div>
                                <div className="site-card-border-less-wrapper col-md-7">
                                    <Card title="Registro Nacional Migratório" bordered={false} style={{ background: "#ececec" }}>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <Form.Item name="rnm" label="Número" >
                                                    <Input placeholder="Número do documento"
                                                        disabled={permissaoUserEditar === false}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-5">
                                                <Form.Item name="validadeRnm" label="Data de validade "
                                                    rules={[
                                                        {
                                                            validator: validarDataValidadeRnm
                                                        }
                                                    ]}>
                                                    <MaskedInput placeholder="Informe a Data" mask="99/99/9999" className='globalInput' />
                                                    {/* <DatePicker format="DD/MM/YYYY"
                                                        disabled={permissaoUserEditar === false}
                                                    ></DatePicker> */}
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <Form.Item name="classificacaoRnm" label="Classificação" >
                                                    <Select placeholder="Selecione"
                                                        disabled={permissaoUserEditar === false}
                                                    >
                                                        <Select.Option key={1} value={"INDETERMINADO"}>Indeterminado </Select.Option>
                                                        <Select.Option key={3} value={"PERMANENTE"}>Permanente</Select.Option>
                                                        <Select.Option key={4} value={"PROVISORIO"}>Provisório </Select.Option>
                                                        <Select.Option key={2} value={"TEMPORARIO"}>Temporario </Select.Option>
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                            <div className="col-md-5">
                                                <Form.Item name="expedicaoRnm" label="Data de expedição "
                                                    rules={[
                                                        {
                                                            validator: validarDataExpedicaoRnm
                                                        }
                                                    ]}  >
                                                    <MaskedInput placeholder="Informe a Data" mask="99/99/9999" className='globalInput' />
                                                    {/* <DatePicker format="DD/MM/YYYY"
                                                        disabled={permissaoUserEditar === false}
                                                    ></DatePicker> */}
                                                </Form.Item>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div >
                            <br />
                            <div className="col-md-full">
                                <Card title="Informações do chamante" bordered={false} style={{ background: "#ececec" }}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Form.Item name="rnmChamante" label="RNM do chamante" >
                                                <Input />
                                            </Form.Item>
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Item name="cpfChamante" label="CPF do chamante" rules={[{ message: 'Insira o CPF' },
                                            { validator: (_, value) => { return validarCPF(value) } }]}>
                                                <MaskedInput mask="999.999.999-99" placeholder="Informe um CPF" className='globalInput'
                                                    disabled={permissaoUserEditar === false}></MaskedInput>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <br />

                            <div className="row">
                                <div className="site-card-border-less-wrapper col-md-12">
                                    <Card bordered={false} style={{ background: "#ececec" }}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <Form.Item name="documento" label="Documento" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
                                                    <Select onChange={(e) => { e === 8 ? setOutro(false) : setOutro(true) }} placeholder="Selecione um Tipo Documento"
                                                        disabled={permissaoUserEditar === false}
                                                    >

                                                        {tipoDocumentos ? tipoDocumentos.map((option, index) => {
                                                            return <Select.Option key={index} value={option.tipoDocumentoID}>
                                                                {option.nome}
                                                            </Select.Option>;
                                                        }) : null}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                            {outro ? null :
                                                <div className="col-md-4">
                                                    <Form.Item name="outro" label="Outro" labelCol={{ span: 4 }} wrapperCol={{ span: 18 }}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: 'Por favor insira uma descrição!',
                                                            }
                                                        ]}>
                                                        <Input placeholder="Descrição"
                                                        />
                                                    </Form.Item>
                                                </div>
                                            }

                                            <div className="col-md-2">
                                                <Form.Item name="arquivo"  >
                                                    {permissaoUserEditar === true ?
                                                        <Upload beforeUpload={() => false} onChange={(e) => handleUpload(e)} name="arquivo" maxCount={1}>
                                                            <Button ghost type="primary" icon={<UploadOutlined

                                                            />}>Anexar imagem</Button>
                                                        </Upload>
                                                        : null}
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <Spin spinning={loadingArquivos}>
                                            <Table dataSource={arquivos} key={'arquivoID'} columns={colunas} pagination={{ pageSize: 3 }} />
                                        </Spin>
                                        <br />
                                        {permissaoUserEditar === true ?
                                            <Button onClick={() => { uploadRequest() }} type="primary">Salvar Documento Anexado </Button>
                                            : null}
                                    </Card >
                                    <Form.Item name="anotacoesGerais" label="Anotações gerais" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                        {/* <SunEditor
                                            setContents={editorState}
                                            onChange={setEditorState}
                                            defaultValue={editorState}
                                            setOptions={options}
                                            lang="pt_br"
                                        /> */}
                                        <EditorTexto editorState={editorState} setEditorState={setEditorState}></EditorTexto>
                                    </Form.Item>

                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-1">
                                    <Form.Item className="align-items-end">
                                        {permissaoUserEditar === true ?
                                            <Button type="primary" htmlType="submit">Salvar</Button>
                                            : null}
                                    </Form.Item>
                                </div>
                            </div>
                        </Form>
                    </Spin>
                    <br />

                </div>
            </div>
        </>
    )

}
const mapStateToProps = (state: any) => ({
    permissao: state.permissao,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(PermissaoAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(Documentacao);


